import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { createRoot } from "react-dom/client";
import "tailwind-base/theme.css";
import App from "./app";
import ErrorBoundary from "./components/ErrorBoundary";
import GrowthbookProvider from "./components/GrowthbookProvider";
import { AppContextProvider } from "./lib/context";
import "./lib/i18n";
import "./lib/settings";
import "./style.css";

const queryClient = new QueryClient();
new EventSource("/esbuild").addEventListener("change", () => location.reload());

const root = createRoot(document.getElementById("root")!);
const searchParams = new URLSearchParams(location.search);
const postalCode = searchParams.get("postal-code");

root.render(
  <ErrorBoundary>
    <GrowthbookProvider>
      <QueryClientProvider client={queryClient}>
        <AppContextProvider postalCode={postalCode}>
          <App skipPostalCode={!!postalCode} />
        </AppContextProvider>
      </QueryClientProvider>
    </GrowthbookProvider>
  </ErrorBoundary>,
);
